<template>
    <div class="cart">
        <div class="cart__wrap">
            <div class="cart__container">
                <h2 class="cart__title">
                    <img
                        class="cart__title--icon"
                        src="~ThemePath/images/cart-green.png"
                        alt="cart"
                    />
                    <span>{{ getTranslatedText("Betslip") }}</span>
                </h2>
                <div
                    v-if="this.$store.state.isShow645"
                    class="betslip__header-tab"
                >
                    <div
                        class="betslip__header-tab-item"
                        :class="{ active: $store.state.stepCart === v.step }"
                        v-for="(v, i) in listMenuGames"
                        :key="i"
                        @click="() => onChangeTabBetslip(v.step)"
                    >
                        {{ getTranslatedText(v.title) }}
                        <div class="betslip__header-quantity">
                            {{ renderQuantityCart(v.step) }}
                        </div>
                    </div>
                </div>
                <div
                    v-if="!this.$store.state.isShow645"
                    class="betslip__header-tab"
                >
                    <div
                        class="betslip__header-tab-item"
                        :class="{ active: $store.state.stepCart !== v.step }"
                        v-for="(v, i) in listMenuGames2"
                        :key="i"
                        @click="() => onChangeTabBetslip(v.step)"
                    >
                        {{ getTranslatedText(v.title) }}
                        <div class="betslip__header-quantity">
                            {{ renderQuantityCart(v.step) }}
                        </div>
                    </div>
                </div>
                <button class="cart__btn--close" @click="$emit('close-cart')">
                    <img src="~ThemePath/images/close-green.png" alt="" />
                </button>
                <div class="cart__content">
                    <div
                        class="cart__content__empty"
                        v-if="$store.state.cartRender?.length === 0"
                    >
                        <p>{{ getTranslatedText("cart empty") }}</p>
                        <button
                            @click="$emit('continue-paying')"
                            class="cart__content__empty__add-bets"
                        >
                            {{ getTranslatedText("Add Bets") }}
                        </button>
                    </div>
                    <div v-else class="cart__content__list--product">
                        <table>
                            <tr
                                v-for="(value, index) in $store.state
                                    .cartRender"
                                :key="index"
                            >
                                <td>
                                    <span>
                                        {{ getTranslatedText(value.title) }}
                                        <span
                                            class="betslip__text bets"
                                            v-if="value.isPariMutuelLotto"
                                        >
                                            ({{
                                                getTranslatedText(
                                                    value.bets <= 1
                                                        ? "single"
                                                        : "multiple[number]",
                                                    {
                                                        number: value
                                                            .selection[0]
                                                            .length,
                                                    }
                                                )
                                            }})
                                        </span>
                                    </span>
                                    <div
                                        class="cart__content__list--product__numbers"
                                    >
                                        <span
                                            v-for="(v, i) in value.selection[0]"
                                            :key="i"
                                            >{{ v
                                            }}<span
                                                v-if="
                                                    i <
                                                    value.selection[0].length -
                                                        1
                                                "
                                                >,</span
                                            ></span
                                        >
                                    </div>
                                </td>
                                <td>
                                    <span>{{
                                        renderDate(value.eventDate)
                                    }}</span>
                                </td>
                                <td>
                                    <span>{{ renderPrice(value.price) }}</span>
                                    <span>
                                        <button
                                            @click="
                                                onShowConfirmRemoveItem(value)
                                            "
                                        >
                                            <img
                                                src="~ThemePath/images/close-green.png"
                                                alt=""
                                            />
                                        </button>
                                    </span>
                                </td>
                            </tr>
                            <tr class="cart__total">
                                <td>{{ getTranslatedText("total") }}</td>
                                <td>
                                    {{
                                        renderPrice(this.$store.state.totalCart)
                                    }}
                                </td>
                            </tr>
                        </table>
                        <div class="cart__btn">
                            <div class="cart__btn__carts">
                                <button
                                    @click="onShowConfirmClear"
                                    class="cart__btn__carts--clear"
                                >
                                    {{ getTranslatedText("Clear") }}
                                </button>
                                <button
                                    @click="onSubmitTransac"
                                    class="cart__btn__carts--pay"
                                    :disabled="isLoadingButton"
                                >
                                    <Loading
                                        v-if="isLoadingButton"
                                        :isLoadingPage="false"
                                        :is-loading-white-color="true"
                                    ></Loading>
                                    <span v-if="!isLoadingButton">{{
                                        getTranslatedText("Pay")
                                    }}</span>
                                    <span v-if="isLoadingButton">{{
                                        getTranslatedText("Submitting")
                                    }}</span>
                                </button>
                            </div>
                            <button
                                :disabled="isLoadingButton"
                                @click="$emit('continue-paying')"
                                class="cart__btn--continue"
                            >
                                <Loading
                                    :is-loading-white-color="true"
                                    v-if="isLoadingButton"
                                    :isLoadingPage="false"
                                ></Loading>
                                {{ getTranslatedText("Continue paying") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import EventBus from "@/utils/EventBus";
import languageMixins from "@/mixins/language/language-mixins";
import pathAssetsMixins from "@/mixins/pathAssets/path-assets-mixins";
import ButtonCommon from "@/components/common/button/index.vue";
import Loading from "@/components/common/loading/index.vue";
import {
    formatDateUTC20,
    formatPrice,
    getDrawName,
    isStrEmpty,
    isArrayEmpty,
    generateCombinations,
} from "@/utils/utils";
import BetslipsService from "@/services/betslip.service";
import { getToken } from "@/services/axios";

export default {
    mixins: [languageMixins, pathAssetsMixins],
    components: { ButtonCommon, Loading },
    props: {
        isLoadingPage: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isLoadingButton: false,
            isToggle: false,
            listMenuGames: [
                {
                    title: "loto 5/90",
                    step: 1,
                },
                {
                    title: "lotto 6 of 45",
                    step: 2,
                },
            ],
            listMenuGames2: [
                {
                    title: "loto 5/90",
                    step: 1,
                },
            ],
        };
    },
    mounted() {
        this.onChangeTabBetslip(this.$store.state.stepCart || 1);
    },
    created() {
        EventBus.$on("on-remove-item-betslip", (param) =>
            this.onRemoveItem(param)
        );
        EventBus.$on("on-clear-betslip", () => this.onClearBetslip());
        EventBus.$on("on-submit-transact", () => this.onSubmitTransac());
    },
    destroyed() {
        EventBus.$off("on-remove-item-betslip");
        EventBus.$off("on-clear-betslip");
        EventBus.$off("on-submit-transact");
    },
    methods: {
        onChangeTabBetslip(step) {
            const payload = {
                step,
            };
            this.$store.dispatch("onSwitchBetslip", payload);
        },
        renderQuantityCart(step) {
            let cart =
                step === 1
                    ? this.$store.state.cart.filter((x) => !x.isPariMutuelLotto)
                    : this.$store.state.cart.filter((x) => x.isPariMutuelLotto);
            return cart.length;
        },

        onShowConfirmClear() {
            const param = {
                title:
                    process.env.VUE_APP_I18N_LOCALE === "fr"
                        ? "warning"
                        : "confirm delete",
                description: "Are you sure you want to delete?",
                nameFunction: "on-clear-betslip",
            };
            EventBus.$emit("on-show-dialog", param);
        },

        onShowToast(title, message, code) {
            if (code === 200) {
                this.$store.dispatch("onClearCart");
                this.isLoadingButton = false;
            } else {
                this.isLoadingButton = false;
            }
            const param = {
                title: title,
                description: message,
                isShowCancel: false,
                nameFunction: "hideModal",
            };
            EventBus.$emit("on-show-dialog", param);
        },

        onShowConfirmRemoveItem(item) {
            const param = {
                title:
                    process.env.VUE_APP_I18N_LOCALE === "fr"
                        ? "warning"
                        : "confirm delete",
                description: "Are you sure you want to delete?",
                nameFunction: "on-remove-item-betslip",
                paramFunction: {
                    item,
                },
            };
            EventBus.$emit("on-show-dialog", param);
        },

        onRemoveItem(param) {
            const payload = {
                item: param.item,
            };
            this.$store.dispatch("onRemoveItemCart", payload);
        },

        onClearBetslip() {
            this.$store.dispatch("onClearCart");
        },

        onToggleBetslip() {
            if (this.$store.state.isScreenMobile) {
                this.isToggle = !this.isToggle;
                EventBus.$emit("on-toggle-betslip-mobile", this.isToggle);
            }
        },

        onShowStatusTransac(code, message) {
            if (code === 200) {
                const param = {
                    text: message || `Transaction completed!`,
                    type: "success",
                };
                EventBus.$emit("show-notications", param);
                this.$store.dispatch("onClearCart");

                this.isLoadingButton = false;
            } else {
                const param = {
                    text: message || `system error!`,
                    type: "error",
                };
                EventBus.$emit("show-notications", param);
                this.isLoadingButton = false;
            }
        },

        async onSubmitTransac() {
            try {
                this.isLoadingButton = true;
                const token = getToken();
                if (!isStrEmpty(token)) {
                    const respCheckdevice =
                        await BetslipsService.deviceBindingcheck();
                    if (respCheckdevice.status === 200) {
                        let isPariMutuelLotto =
                            this.$store.state.stepCart === 1;
                        let type = isPariMutuelLotto
                            ? "multi-lotto"
                            : "pari-mutuel-lotto";
                        let payload = isPariMutuelLotto
                            ? this.$store.state.transact
                            : this.$store.state.transactPariLotto;
                        if (!isArrayEmpty(payload)) {
                            payload.forEach((item) => {
                                delete item.id;
                            });
                            const resp = await BetslipsService.transactLotto(
                                payload,
                                type
                            );
                            if (resp.code === 200) {
                                let paramPrint = null;
                                let dataEntries = resp.data.bets.entries.map(
                                    (x) => {
                                        let drawName = "";
                                        if (isPariMutuelLotto) {
                                            this.$store.state.transact = [];
                                            const dateFormat = formatDateUTC20(
                                                x.event.drawDate
                                            );
                                            let date = `${dateFormat.hour}`;
                                            drawName = getDrawName(date);
                                        } else {
                                            this.$store.state.transactPariLotto =
                                                [];
                                            drawName = this.getTranslatedText(
                                                x.game.game
                                            );
                                        }

                                        let item = {
                                            ...x,
                                        };

                                        item.game["game"] =
                                            this.getTranslatedText(x.game.game);
                                        item.event["drawName"] = drawName;

                                        if (!isPariMutuelLotto) {
                                            let numberSelect =
                                                x.market.market.slice(-1);
                                            item.game[
                                                "game"
                                            ] += ` ${this.getTranslatedText(
                                                "Milliardaire"
                                            )}`;
                                            if (
                                                x.entry.bet[0].length >
                                                numberSelect
                                            ) {
                                                item["combinations"] =
                                                    generateCombinations(
                                                        Number(
                                                            x.entry.bet[0]
                                                                .length
                                                        ),
                                                        Number(numberSelect)
                                                    );
                                                item[
                                                    "type"
                                                ] = `${this.getTranslatedText(
                                                    "multiplePrint"
                                                )}${x.entry.bet[0].length}`;
                                            } else {
                                                item[
                                                    "type"
                                                ] = `${this.getTranslatedText(
                                                    "simple"
                                                )}`;
                                                item["combinations"] = 1;
                                            }
                                        }
                                        return item;
                                    }
                                );

                                resp.data.bets["entries"] = dataEntries;
                                paramPrint = resp.data;

                                this.onShowToast("success", resp.message, 200);
                                parent.postMessage(
                                    {
                                        command: "print-rebet-ticket",
                                        param: paramPrint,
                                    },
                                    "*"
                                );
                            } else {
                                this.onShowToast("error", resp.message, 400);
                            }
                        }
                    } else {
                        this.onShowToast(
                            "success",
                            respCheckdevice.message,
                            401
                        );
                    }
                    this.isLoadingButton = false;
                } else {
                    const param = {
                        text: `please login!`,
                        type: "error",
                    };
                    EventBus.$emit("show-notications", param);
                    this.isLoadingButton = false;
                }
            } catch (error) {
                this.isLoadingButton = false;

                console.log(error);
            }
        },

        // format
        renderDate(date) {
            const dateFormat = formatDateUTC20(date);

            let valueDate = `${dateFormat.day}/${dateFormat.month}/${dateFormat.year} ${dateFormat.hour}:${dateFormat.minutes}`;

            return valueDate;
        },

        renderPrice(price, decimal = 0) {
            return formatPrice(price, decimal);
        },

        renderDrawDate(date) {
            const dateFormat = formatDateUTC20(date);

            let valueDate = `${dateFormat.hour}`;

            return valueDate;
        },
    },
};
</script>
<style lang="scss">
@import "~ThemePath/scss/cart/_index.scss";
</style>
